import { useSelector } from "react-redux";
import type { AppState } from "~/store/root-reducer.ts";

export default function useAppSelector<T = unknown>(
	selector: (state: AppState) => T,
): T {
	return useSelector<AppState, T>(selector);
}
